import { render, staticRenderFns } from "./kpzq.vue?vue&type=template&id=324715f4&scoped=true"
import script from "./kpzq.vue?vue&type=script&lang=js"
export * from "./kpzq.vue?vue&type=script&lang=js"
import style0 from "./kpzq.vue?vue&type=style&index=0&id=324715f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324715f4",
  null
  
)

export default component.exports